module.exports = __webpack_public_path__ + "static/media/Amit.3e57f740.jpeg";